import React, { useState, useEffect, useRef } from 'react'
import { IconButton } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import Stack from '@mui/material/Stack'
import MetricCard from "./MetricCard"


const MetricCarousel = ({ cards }) => {

    const minCardSize = 350

    const carouselRef = useRef(null)

    const [currentIndex, setCurrentIndex] = useState(0)
    const [visibleCards, setVisibleCards] = useState(1)

    useEffect(() => {
        if (carouselRef.current) {
            const updateNumberOfCards = () => {
                setVisibleCards(
                    Math.floor(carouselRef.current.clientWidth / minCardSize)
                )
            }

            updateNumberOfCards()

            window.addEventListener('resize', updateNumberOfCards)

            return () => {
                window.removeEventListener('resize', updateNumberOfCards)
            }
        }
    }, [])

    // Clamp currentIndex when the card count shrinks (e.g. an alert card
    // disappears once its condition clears after a realtime update).
    useEffect(() => {
        if (currentIndex > 0 && currentIndex >= cards.length) {
            setCurrentIndex(Math.max(0, cards.length - visibleCards))
        }
    }, [cards.length, currentIndex, visibleCards])

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + cards.length) % cards.length)
    }

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % cards.length)
    }

    return (
        <Stack direction="row" spacing={2} sx={{ width: '100%', alignItems: 'center' }}>

            {/* Left Navigation Button */}
            <IconButton onClick={handlePrev} disabled={currentIndex === 0}>
                <ChevronLeft />
            </IconButton>

            {/* MetricCarousel content */}
            <div
                ref={carouselRef}
                style={{
                    overflowX: 'hidden',
                    flex: 1,
                    display: 'flex',
                    position: 'relative',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        transition: 'transform 0.5s ease',
                        transform: `translateX(-${currentIndex * (100 / visibleCards)}%)`,
                        width: `${(cards.length / visibleCards) * 100}%`,
                    }}
                >
                    {cards.map(({ cardProps, loading }, index) => (
                        <div
                            key={index}
                            style={{
                                flex: `0 0 ${100 / visibleCards}%`,
                                boxSizing: 'border-box',
                                padding: '0 8px',
                            }}
                        >
                            <MetricCard
                                loading={loading}
                                title={cardProps?.title}
                                metric={cardProps?.metric}
                                subtitle={cardProps?.subtitle}
                                icon_obj={cardProps?.icon_obj}
                                alert={cardProps?.alert}
                            />
                        </div>
                    ))}
                </div>
            </div>

            {/* Right Navigation Button */}
            <IconButton onClick={handleNext} disabled={currentIndex + visibleCards >= cards.length}>
                <ChevronRight />
            </IconButton>

        </Stack>
    )
}

export default MetricCarousel